// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"0cf8f58e","527":"cb7eb3ff","556":"eb601031"}[chunkId] + ".chunk.css";
};